<template>
    <form-group
        v-bind="form_group_props"
    >
        <template v-slot:read_only>
            <slot name="read_only">
                <input :disabled="true" :value="display_value" class="uk-width-1-1" />
            </slot>
        </template>
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:hint><slot name="hint"></slot></template>
        <input-group
            glyph="calendar"
            v-bind="input_group_props"
        >
            <input
                ref="field"
                :id="identifier"
                :name="name"
                :value="date_value(this.real_format)"
                autocomplete="off"
                :aria-describedby="!!has_slot('hint')?`${identifier}-description`:false"
                :disabled="disabled"
                :placeholder="placeholder"
                :class="{ [`uk-width-${width}`]: true, [`uk-text-${align}`]: true, [`uk-form-${size}`]: true, [`uk-form-${color}`]: true }"
                class="uk-width-1-1"
                @focus="show($event)"
                @keyup.stop="keyup"
                @change="set_date($event)"
            />
        </input-group>
    </form-group>
</template>

<script type="text/javascript">
import is_nibnut_component from "../mixins/IsNibnutComponent"

import FormGroup from "./FormGroup"
import InputGroup from "./InputGroup"

export default {
    mixins: [is_nibnut_component],
    components: {
        FormGroup,
        InputGroup
    },
    mounted () {
        window.UIkit.datepicker(this.$refs.field, this.datepicker_options).on("hide.uk.datepicker", () => {
            this.set_date({ target: this.$refs.field })
        })
    },
    methods: {
        show (event) {
            event.target.select()
        },
        set_date (event) {
            let date_string = event.target.value
            if(!date_string) this.date_picked(null)
            else if(this.legacy) {
                if(this.input_format === "MM-DD-YYYY") {
                    const matches = date_string.match(/^(\d{1,2})[\s\-./]+(\d{2}|\d{4})$/)
                    if(matches) date_string = matches[1] + "-" + this.$root.applicationSettings.default_date_day + "-" + matches[2]
                    date_string = date_string.replace(/([\s\-./]+)(\d{2})$/, "$120$2")
                }
                if(date_string !== this.date_value(true)) this.date_picked(this.$moment(date_string))
            } else {
                if(date_string !== this.date_value(this.real_input_format)) this.date_picked(this.$moment(date_string, this.real_format))
            }
        },
        date_picked (picked_date) {
            const formatted_data = picked_date ? picked_date.format(this.real_input_format) : null
            this.$emit("input", formatted_data, this.name)
        },
        date_value (filter = null) {
            if(!this.value) return ""
            const value = this.legacy ? this.$moment(this.value) : this.$moment(this.value, this.real_input_format)
            if(!filter) return value
            return this.legacy ? value.format(this.real_input_format) : value.format(filter)
        },
        focus (event) {
            event.target.select()
        },
        keyup (event) {
            if(!event) return
            if(this.inputOnEnter && (event.code === "Enter")) {
                if(document.activeElement && document.activeElement.blur) document.activeElement.blur()
                else this.set_date(event)
            } else this.set_date(event)
        },
        blur (event) {
            this.set_date(event)
        },
        changed (event) {
            this.set_date(event)
        }
    },
    computed: {
        datepicker_options () {
            return {
                offsettop: 0,
                // minDate: this.minDate,
                // maxDate: this.maxDate,
                format: this.legacy ? this.real_input_form : this.real_format,
                pos: this.calendarPosition
            }
        },
        form_group_props () {
            return {
                id: this.id,
                name: this.name,
                value: this.value,
                required: this.required,
                editable: this.editable,
                error: this.error,
                waiting: this.saving
            }
        },
        input_group_props () {
            return {
                glyph: this.glyph,
                width: this.width
            }
        },
        display_value () {
            if(!this.value) return ""
            return this.$moment(this.value).format(this.format)
        },
        real_format () {
            if(this.legacy) return "MMMM DD, YYYY"
            return this.format
        },
        real_input_format () {
            if(this.legacy) return "MM-DD-YYYY"
            return this.input_format
        }
    },
    /*
    methods: {
        set_date () {
            if(!this.$refs.input) return
            let date_string = this.$refs.input.value
            if(this.input_format === "MM-DD-YYYY") {
                let matches = null
                if(matches = date_string.match(/^(\d{1,2})[\s\-\.\/]+(\d{2}|\d{4})$/)) date_string = matches[1] + "-" + this.$root.applicationSettings.default_date_day + "-" + matches[2]
                date_string = date_string.replace(/([\s\-\.\/]+)(\d{2})$/, "$120$2")
                date_string = date_string.replace(/^(\d{1,2})[\s\-\.\/]+(\d{1,2})[\s\-\.\/]+(\d{2}|\d{4})$/, "$3-$1-$2")
            }
            if(date_string !== this.date_value()) {
                this.changedValue({target: {name: this.name}}, date_string, this.value)
            }
        }
    },
    */
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: ""
        },
        width: {
            type: String,
            default: "1-1"
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal|large)$/i),
            default: "normal"
        },
        color: {
            type: String,
            validator: prop => !prop || !!prop.match(/^(danger|success)$/i),
            default: ""
        },
        align: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(left|right|center)$/i),
            default: "left"
        },
        required: {
            type: Boolean,
            required: true
        },
        minDate: {
            default: false
        },
        maxDate: {
            default: false
        },
        format: {
            type: String,
            default: "MM-DD-YYYY"
        },
        calendarPosition: {
            type: String,
            default: "auto"
        },
        placeholder: {
            type: String,
            default: "(Never)"
        },
        editable: {
            type: Boolean,
            default: true
        },
        inputOnEnter: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        live: {
            type: Boolean,
            default: false
        },
        saving: {
            type: Boolean,
            default: false
        },
        invalid: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        },
        legacy: { // format hard-coded to "MMMM DD, YYYY" and input_format hard-coded to "MM-DD-YYYY"
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            input_format: "YYYY-MM-DD"
        }
    }
}
</script>
